<ngb-alert [type]="type" class="alert" (close)="close()"><span class="alert-message">{{ message }}</span></ngb-alert>
